import { put, takeLatest, call } from "redux-saga/effects";
import OrdsInfoplanActions, {
  Types as OrdsInfoplanTypes,
} from "../../stores/ordsInfoplan/Actions";
import OrdsInfoplanService from "../../services/ordsInfoplan/OrdsInfoplanService";
import ResponseCode from "../../services/ResponseCode";

function* obtenerEspecialidadesMedicas(request) {
  yield put(OrdsInfoplanActions.obtenerEspecialidadesMedicasLoading());

  try {
    const especialidadesResponse = yield call(
      OrdsInfoplanService.obtenerEspecialidadesMedicas,
      request.payload
    );

    if (!especialidadesResponse?.items) {
      yield put(
        OrdsInfoplanActions.obtenerEspecialidadesMedicasFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Error en la respuesta del servicio",
        })
      );
      return;
    }

    yield put(
      OrdsInfoplanActions.obtenerEspecialidadesMedicasSuccess(especialidadesResponse)
    );
  } catch (error) {
    yield put(
      OrdsInfoplanActions.obtenerEspecialidadesMedicasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error al obtener especialidades médicas",
      })
    );
  }
}

const exportedArray = [
  takeLatest(
    OrdsInfoplanTypes.OBTENER_ESPECIALIDADES_MEDICAS,
    obtenerEspecialidadesMedicas
  ),
];

export default exportedArray;

